// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";

function merge(param) {
  switch (param.TAG | 0) {
    case /* Basic */0 :
        const $$default = param._2;
        return function (t, t$p) {
          if (Caml_obj.caml_equal(t$p, $$default)) {
            return t;
          } else {
            return t$p;
          }
        };
    case /* Basic_opt */1 :
        const Message = param._1;
        if (typeof Message !== "number" && Message.TAG === /* Message */1) {
          const Message$1 = Message._0;
          return function (t, t$p) {
            if (t === undefined) {
              if (t$p !== undefined) {
                return Caml_option.some(Caml_option.valFromOption(t$p));
              } else {
                return ;
              }
            }
            const t$1 = Caml_option.valFromOption(t);
            if (t$p !== undefined) {
              return Caml_option.some(Curry._2(Message$1.merge, t$1, Caml_option.valFromOption(t$p)));
            } else {
              return Caml_option.some(t$1);
            }
          };
        }
        return function (t, t$p) {
          if (t$p !== undefined) {
            return t$p;
          } else {
            return t;
          }
        };
    case /* Basic_req */2 :
        const Message$2 = param._1;
        if (typeof Message$2 !== "number" && Message$2.TAG === /* Message */1) {
          return Message$2._0.merge;
        }
        return function (param, t$p) {
          return t$p;
        };
    case /* Repeated */3 :
    case /* Map */4 :
        return Stdlib__List.append;
    case /* Oneof */5 :
        return Stdlib.failwith("Implementation is part of generated code");
    
  }
}

export {
  merge ,
}
/* No side effect */
